module.exports = __webpack_public_path__ + "img/Steve Fau.395dcde1.jpg";